import { EventsManager } from "@game-libs/events-manager";
import { useState, useEffect } from "react";

const FLASH_ANIMATION = `
  @keyframes flash-fade {
    0% { opacity: 0.5; }
    2% { opacity: 1; }
    20% { opacity: 1; }
    100% { opacity: 0; }
  }
`;

export function FlashOverlay({ color = 'white' }) {
  const { on } = EventsManager();
  const [flashKey, setFlashKey] = useState(0);

  useEffect(() => {
    return on('flash_now', () => {
      setFlashKey((k) => k + 1);
    });
  }, []);

  return (
    <>
      <style>{FLASH_ANIMATION}</style>
      {flashKey > 0 && (
        <div
          key={flashKey}
          style={{
            position: "fixed",
            inset: 0,
            background: color,
            pointerEvents: "none",
            zIndex: 9999,
            opacity: 0,
            animation: "flash-fade 1500ms ease-out",
          }}
        />
      )}
    </>
  );
}